import React, { useEffect, useRef } from 'react';

import { Chevron, Mask, MobileStroke, PillInner, PillMask, Stroke, StrokeWrapper, TwitterHandle } from './styles';

export interface PillProps {
    hasOnlyOne: boolean;
    isSmall: boolean;
    showChevron?: boolean;
    showTwitterHandle?: boolean;
    animateTwitterHandle?: boolean;
    twitterHandleLength?: number;
    twitterHandle?: string;
    updateHandleLength?(val: number): void;
}

export function Pill({
    showChevron = false,
    showTwitterHandle,
    twitterHandle,
    animateTwitterHandle,
    twitterHandleLength,
    hasOnlyOne,
    isSmall,
    updateHandleLength,
}: PillProps) {
    // either use showChevron OR showTwitterHandle and twitterHandle, not both together
    const handleRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        const timeoutid = setTimeout(() => {
            if (handleRef && handleRef.current && updateHandleLength) {
                updateHandleLength(handleRef.current.clientWidth + 80);
            }
        }, 800); // delay time in ms for the animation

        return () => clearTimeout(timeoutid);
    }, [updateHandleLength]);

    return (
        <PillMask
            isSmall={isSmall}
            hasOnlyOne={hasOnlyOne}
            showChevron={showChevron}
            showTwitterHandle={showTwitterHandle}
            twitterHandleLength={twitterHandleLength}
            animateTwitterHandle={animateTwitterHandle}
        >
            <PillInner isSmall={isSmall}>
                <StrokeWrapper isSmall={isSmall}>{isSmall ? <MobileStroke /> : <Stroke />}</StrokeWrapper>

                <Mask isSmall={isSmall}>
                    {showTwitterHandle && (
                        <TwitterHandle isSmall={isSmall} ref={handleRef}>
                            {twitterHandle}
                        </TwitterHandle>
                    )}

                    {showChevron && <Chevron />}
                </Mask>
            </PillInner>
        </PillMask>
    );
}
